import { Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { HourBlock, BarberBlock, AppointmentRow } from './appointments.defs';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { AppService } from '../app/app.service';
import { BarbersService } from '../barbers/barbers.service';
import { forkJoin, timer, Subscription, fromEvent } from 'rxjs';
import { AppointmentsService } from './appointments.service';
import { Appointment } from './appointment';
import { ServicesService } from '../services/services.service';
import { ClientsService } from '../clients/clients.service';
import { MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { startWith, debounceTime, debounce, catchError } from 'rxjs/operators';
import { AppointmentFilterComponent } from './filter-dialog.component';
import { FilterDialogOptions } from './filter-dialog.defs';
import { Barber } from '../barbers/barber';
import { AppointmentComponent } from './appointment.component';
import { environment } from 'src/environments/environment';
import { SettingsRow } from '../settings/settings.defs';
import { SettingsService } from '../settings/settings.service';
import { ShiftsComponent } from '../shifts/shifts.component';

/** handle some setting based stuff quickly */
let _initialFilter = localStorage.getItem('appointments-filters'),
	_defaultSettings: FilterDialogOptions = {
		showIncomplete: true,
	},
	_initalSettings: FilterDialogOptions;
if (_initialFilter) {
	try {
		_initalSettings = JSON.parse(_initialFilter);
	} catch (err) {
		console.warn('bad encoding on filter settings');
	}
}
if (!_initalSettings) {
	_initalSettings = _defaultSettings;
}

const NOW = new Date();

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentsComponent implements OnInit {

	constructor(
		public app: AppService,
		private _barbers: BarbersService,
		private _appointments: AppointmentsService,
		private _services: ServicesService,
		private _clients: ClientsService,
		private _settings: SettingsService,

		private _cd: ChangeDetectorRef,
		private _dom: DomSanitizer,
		private _dialog: MatDialog,
	) {
	}

	dateControl = new FormControl(this.app.date.value);
	waitlist: Appointment[] = [];
	now = new Date();
	hourBlocks: HourBlock[] = [];
	barbers: BarberBlock[] = [];
	minDate: Date;
	maxDate: Date;
	currentTimeTop: Number;
	timeBarThickness = 3;
	rowHeight = 24;
	rowMinHeight = 24;
	settings: SettingsRow;

	// DND stuff
	activeDrag: Appointment;
	private _dndInvalid = false;

	@Input() disableWaitlist: boolean = false;

	
	filterOptions: FilterDialogOptions = _initalSettings;


	private _date: Date;
	get date() { return this._date };
	@Input() set date(date) {
		if (date !== this._date) {
			this._date = date;	
			this._load(date);
		}
	}

	get mainTemplateColumns(): SafeStyle {
		const all = this.filterOptions.showAllBarbers,
			barbers = all ? this.barbers : this.barbers.filter(b => !!b.start),
			ret = ['auto']
				.concat(barbers.map(b => {
					return b.start ? '1fr' : '75px';
				}));
		// if (!this.disableWaitlist) {
		// 	ret.push('.5fr');
		// }
		return this._dom.bypassSecurityTrustStyle(ret.join(' '));
	}

	@Input() minuteIncrement = 15; // minutes
	@ViewChild('headerSlug') headerSlug: ElementRef<HTMLElement>;
	@ViewChild('mainElement') mainElement: ElementRef<HTMLElement>;
	@ViewChild('titleBar', {read: ElementRef}) titleBar: ElementRef<HTMLElement>;

	normalVersion() {
		window.location.href = 'https://thebarber.auxiliumgroup.com/apps/thebarber/appointments/';
	}

	openShifts() {
		const ref = this._dialog.open(ShiftsComponent, {
			data: this.app.date.value
		})
		ref.afterClosed()
			.subscribe(changes => {
				if (changes) {
					this.refresh();
				}
			})
	}

	refresh() {
		this._clients.fetch().subscribe(() => {
			this._load(this.app.date.getValue());
		})
	}

	isLunch(a: Appointment): boolean {
		const s = this.settings;
		if (a && a.client && s) {
			return a.client.customerId === s.lunchNumberRef && a.services.some(svc => svc.id === s.lunchServiceRef);
		}
		return false;
	}

	// this is an expensive operation, can we move it???
	isDisabled(date: Date, barber: BarberBlock): boolean {
		if (!barber.start) return true;
		const start = barber.start,
			end = barber.end,
			cur = new Date(date);
		cur.setFullYear(start.getFullYear(), start.getMonth(), start.getDate());
		return cur < start || cur >= end;
	}

	noop() { };
	
	dragStart(evt: DragEvent, a: Appointment) {
		this.activeDrag = a;
	}

	dragEnter(evt: any, date: Date, barber: BarberBlock) {
		const invalid = this._dndInvalid = this.isDisabled(date, barber);
		if (!invalid) {
			evt.currentTarget.classList.add('dnd-active-target');
		}
	}
	dragLeave(evt: any) {
		evt.currentTarget.classList.remove('dnd-active-target');
	}
	dragOver(evt: DragEvent) {
		evt.preventDefault();
	}
	dragEnd(evt: any) {
		evt.currentTarget.classList.remove('dnd-active-target');
	}
	drop(evt: any, slot: Date, barber: BarberBlock) {
		evt.currentTarget.classList.remove('dnd-active-target');

		if (this.app.offline.getValue()) {
			alert('The server is currently unavailable, this operation will be cancelled');
			return;
		}
		
		if (!this._dndInvalid) {

			const appt = this.activeDrag,
				sel = new Date(this.app.date.getValue());
			sel.setHours(slot.getHours(), slot.getMinutes(), 0, 0);

			this._updateAppt({
				id: appt.id,
				Appointment: sel,
				BarberRef: barber.id,
			});
		}
	}
	private _touchStart: number;
	touchStart(evt: TouchEvent, a: Appointment) {
		this.activeDrag = a;
		this._touchStart = new Date().getTime();
	}
	
	touchCancel(evt: TouchEvent, a: Appointment) {
		this.activeDrag = null;
	}
	touchMove(evt: TouchEvent) {
		if (this.activeDrag) {

			evt.preventDefault();
			const args = this._getTouchOverArgs(evt);

			Array.from(document.querySelectorAll('.dnd-active-target, .drop-target-active'))
				.forEach(node => node.classList.remove('dnd-active-target', 'drop-target-active'));
			switch (args) {
				case 'waitlist':
					const wl = document.querySelector('.waitlist-slots'),
						lunch = this.settings.lunchServiceRef,
						a = this.activeDrag,
						isLunch = !!(a.services.find(s => s.id === lunch));

					if (wl && !isLunch) {
						wl.classList.add('drop-target-active');
					}
					break;

				case null:
					break;
				default:
					if (!this.isDisabled(args.slot, args.barber)) {
						args.node.classList.add('dnd-active-target');
					}
					
			}
		}
	}
	touchEnd(evt: TouchEvent) {
		const active = this.activeDrag,
			now = new Date().getTime();

		if (now - this._touchStart > 200 && active) {

			const args = this._getTouchOverArgs(evt);
			if (args === 'waitlist') {
				const lunch = this.settings.lunchServiceRef,
					a = this.activeDrag,
					isLunch = !!(a.services.find(s => s.id === lunch));
				if (!isLunch) {
					const Appointment = active.created;
					this._updateAppt({
						id: active.id,
						BarberRef: null,
						Appointment,
					});
				}
			} else if (args && args.slot && args.barber && !this.isDisabled(args.slot, args.barber)) {
				this.drop(evt, args.slot, args.barber);
			}
		}

		Array.from(document.querySelectorAll('.dnd-active-target, .drop-target-active'))
			.forEach(node => node.classList.remove('dnd-active-target', 'drop-target-active'));

		this.activeDrag = null;	
	}

	private _getTouchOverArgs(evt: TouchEvent): 'waitlist' | {slot: Date, barber: BarberBlock, node: Element} {

		const ct = evt.changedTouches[0],
			target = document.elementFromPoint(ct.clientX, ct.clientY),
			barberNode = target ? target.closest('[touch-hour][touch-minute][touch-barber]') : null;

		if (barberNode) {
			const h = +barberNode.getAttribute('touch-hour'),
				m = +barberNode.getAttribute('touch-minute'),
				barber = +barberNode.getAttribute('touch-barber'),
				current = this.app.date.getValue(),
				d = new Date(current),
				block = this.barbers.find(b => b.id === barber);

			d.setHours(h, m, 0, 0);

			return {slot: d, barber: block, node: barberNode};

		} else if (target.closest('.waitlist-slots')) {

			return 'waitlist';

		}

		return null;
	}

	private _updateAppt(appt: AppointmentRow) {
		this._appointments.update(appt)
			.subscribe(
				() => {
					const main = document.querySelector('.main');
					this._load(this.app.date.getValue(), main ? main.scrollTop : 0);
				},
				err => {
					alert('there was a problem changing the appointment, please contact the administrator');
				}
			)
	}

	dropWaitlist(evt: any) {

		const n = evt.currentTarget,
			appt = this.activeDrag,
			lunch = this.settings.lunchServiceRef,
			a = this.activeDrag,
			isLunch = !!(a.services.find(s => s.id === lunch)),
			sel = new Date(this.app.date.getValue());

		n.classList.remove('drop-target-active');

		if (this.app.offline.getValue()) {
			alert('The server is currently unavailable, this operation will be cancelled');
			return;
		}

		if (!isLunch) {
			sel.setHours(appt.created.getHours(), appt.created.getMinutes(), 0, 0);
			
			this._updateAppt({
				id: appt.id,
				Appointment: sel,
				BarberRef: null,
			});
		}
	}
	dragOverWaitlist(evt: any) {
		evt.preventDefault();
	}
	dragEnterWaitlist(evt: any) {
		const n = evt.currentTarget,
			lunch = this.settings.lunchServiceRef,
			a = this.activeDrag,
			isLunch = !!(a.services.find(s => s.id === lunch));
		if (!isLunch) {
			n.classList.add('drop-target-active');	
		}
	}
	dragLeaveWaitlist(evt: any) {
		const n = evt.currentTarget;
		n.classList.remove('drop-target-active');
	}

	addAppointment(date: Date, b?: BarberBlock) {
		const disabled = this.isDisabled(date, b);
		if (this.app.offline.getValue()) {
			alert('The server is currently unavailable, unable to create a new appointment');
			return;
		}
		if (!disabled || (!b && !this.disableWaitlist)) {
			this._addAppointment(date, b);
		}
	}

	addWalkin() {
		const d = new Date(this.app.date.value),
			now = new Date();
		d.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);
		return this._addAppointment(d);
	}

	private _addAppointment(date: Date, barber?: BarberBlock) {
		
		const sel = this.dateControl.value;
		date.setFullYear(sel.getFullYear(), sel.getMonth(), sel.getDate());
		const b = barber ? this._barbers.all.getValue().find(b => b.id === barber.id) : null,
			appt = new Appointment({Appointment: date}, null, null, b);
		this.showAppointment(null, appt);
	}

	showAppointment(evt?: Event, appt?: Appointment) {
		if (evt) {
			evt.preventDefault();
			evt.cancelBubble = true;
		}
		if (appt.canEdit || !appt.id) {
			const ref = this._dialog.open(AppointmentComponent, {
				data: {
					appointment: appt || null,
					schedule: this.barbers,
				},
				// disableClose: true,
				width: '95vw',
				maxWidth: '95vw',
				height: '95vh',
				maxHeight: 1920 / 2 + 'px',
				panelClass: 'no-padding',
			});

			ref.afterClosed()
				.subscribe((updated?: Appointment) => {
					if (updated) {
						const today = new Date();
						this.refresh();
						if (this.app.setDate(today)) {
							setTimeout(() => {
								this.dateControl.setValue(today);
							})
						}
					}
				});

			return false;
		}
	}

	incrementDate(days: number = 1) {
		const v = new Date(this.dateControl.value);
		v.setHours(0,0,0,0);
		v.setDate(v.getDate() + days);
		this.dateControl.setValue(v);
	}

	openFilter() {

		const filter = this.filterOptions,
			before = JSON.stringify(filter),
			ref = this._dialog.open(AppointmentFilterComponent, {
				data: filter
			});

		ref.afterClosed()
			.subscribe((resp: FilterDialogOptions) => {
				const after = JSON.stringify(filter);
				if (after !== before) {
					localStorage.setItem('appointments-filters', after);
					this._cd.markForCheck();
				}
			});
	}

	private _cellToggle(fn: 'add' | 'remove', evt: Event, hour: number, minute: number, barber: Barber) {
		const elem = this.mainElement.nativeElement,
			qry = `[hour="${hour}"], [minute="${hour}:${minute}"], .barber-header[barber="${barber.id}"]`,
			target = <Element>evt.target;
		if (elem) {
			Array.from(elem.querySelectorAll(qry))
				.concat([target])
				.forEach(node => node.classList[fn]('highlight'));
		}
	}
	cellEnter(evt: Event, hour: number, minute: number, barber: Barber) {
		this._cellToggle('add', evt, hour, minute, barber);
	}
	cellLeave(evt: Event, hour: number, minute: number, barber: Barber) {
		this._cellToggle('remove', evt, hour, minute, barber);
	}

	private _todayTimer: Subscription;
	
	private _load(date: Date, scrollToY?: number) {

		this.app.loading = true;
		forkJoin(
			this._barbers.fetch(),
			this._appointments.byWeekday(date),
			this._services.fetch(),
		)
		.subscribe(
			resp => {
				const hours = resp[1].hours.rows.pop(),
					shifts = resp[1].shifts.rows,
					appts = resp[1].appointments.rows,
					services = resp[2],
					staff = resp[0],
					weekday = date.getDay(),
					// showAppointment = environment.debug ? environment.debug.showAppointment : 0,
					systemBarberIds = staff
						.filter(s => s.system)
						.map(s => s.id);
				let autoOpen: Appointment;

				if (hours) {

					const min = new Date(hours.open),
						max = new Date(hours.close),
						hourRows: HourBlock[] = this.hourBlocks,
						inc = this.minuteIncrement,
						minDate = this.minDate = new Date(),
						maxDate = this.maxDate = new Date(),
						clients = this._clients.index;

					let minStamp: number;

					min.setSeconds(0,0);
					max.setMinutes(max.getMinutes() - inc, 0, 0);
					minStamp = min.getTime();

					// update our globals
					minDate.setHours(min.getHours(), min.getMinutes(), 0, 0);
					maxDate.setHours(max.getHours(), max.getMinutes(), 0, 0);

					hourRows.length = 0;

					// const minStamp = min.getTime();
					for (let d = new Date(min); d <= max; d.setMinutes(d.getMinutes() + inc)) {

						const time = new Date(d),
							stamp = time.getTime(),
							hour = time.getHours(),
							minutes = time.getMinutes(),
							isPm = hour >= 12;

						let h: HourBlock;

						if (minStamp === stamp || !minutes) {
							h = {hour, isPm, minutes: []};
							hourRows.push(h);
						} else {
							h = hourRows.find(row => row.hour === hour && row.isPm === isPm)
						}

						h.minutes.push({
							minute: minutes,
							date: time,
							barbers: [],
							disabled: false,
						})
					}

					this.barbers = staff
						.filter(barber => !barber.system)
						.map(barber => {
							const shift = shifts.find(s => s.BARBERRef === barber.id),
								schedule = barber.schedule.get(weekday);
							let barberRow: BarberBlock;
							if (shift) {
								barberRow = {
									id: barber.id,
									name: barber.name,
									start: shift._available ? shift.START : null,
									end: shift._available ? shift.END : null,
									appointments: [],
								}
							} else {
								barberRow = {
									id: barber.id,
									name: barber.name,
									start: schedule ? schedule.start : null,
									end: schedule ? schedule.end : null,
									appointments: [],
								}
							}

							barberRow.scheduled = !!(schedule.start);
							barberRow.working = !!(barberRow.start);

							// we need to scan the appointments and move them out
							appts.filter(appt => appt.BarberRef === barber.id)
								.forEach(appt => {
									const service = services.find(s => s.id === appt.SERVICERef),
										existing = barberRow.appointments.find(a => {
											return a.barber.id == appt.BarberRef && a.atSameTime(appt.Appointment) && (appt.cancelled_0 || false) === a.cancelled && !!(appt.INVOICERef) === a.invoiced && a.client.id === appt.ClientRef
										}),
										row = new Appointment(appt, service, clients.get(appt.ClientRef), barber);
									if (existing) {
										existing.children.push(row);
									} else {
										barberRow.appointments.push(row);
									}
									// if (showAppointment && row.id === showAppointment) {
									// 	autoOpen = row;
									// }
								})

							return barberRow;
						});

					// scan quickly, and find waitlisted items
					this.waitlist = appts.filter(appt => {
							return !!(!appt.BarberRef || systemBarberIds.some(id => id === appt.BarberRef) && !appt.closed)
						})
						.map(appt => {
							const service = services.find(s => s.id === appt.SERVICERef),
								a = new Appointment(appt, service, clients.get(appt.ClientRef));
							return a;
						})
						.filter((val, idx, arr) => {
							const matches = arr.filter(a => {
								return val.id !== a.id && val.atSameTime(a.date) && val.client === a.client;
							})
							if (matches.length) {
								if (matches.some(match => !!match.children.find(child => child.id === val.id))) {
									return false;
								} else {
									matches.forEach(match => val.children.push(match));
								}
							}
							return true;
						});


					// sort them, people that work first, then unschedulde, then alphabetic
					this.barbers.sort((a, b) => {

						if (a.start && !b.start) {
							return -1;
						} else if (b.start) {
							return 1;
						} else {
							const x = a.name.toLowerCase(),
								y = a.name.toLowerCase();
							return x < y ? -1 : x > y ? 1 : 0;
						}
					})

					/**
					 * can we seed the block disabled states?
					 */

				}
				this.app.loading = false;

				// change detection should have ran, our stuff should be available at this point
				// but, we need to let it catch up before we try this
				setTimeout(() => {

					this._cd.detectChanges();
					this.updateClock()
					// scroll if it was set
					if (scrollToY) {
						const node = document.querySelector('.main');
						if (node) {
							node.scrollTo({top: scrollToY});
						}
					}
					if (autoOpen) {
						this.showAppointment(null, autoOpen);
					}

					this._onResize();
				}, 100);

			},
			err => {
				console.warn(err);
			}
		);
	}

	getAppointments(hour: number, minute: number, barber: BarberBlock): Appointment[] {
		const inc = this.minuteIncrement; 
		return barber.appointments
			.filter(appt => {
				if (appt.date.getHours() === hour) {
					// check the minute range
					const minutes = appt.date.getMinutes(),
						max = minute + inc;
					return minutes >= minute && minutes < max;
				}
				return false;
			})
	}

	getAppointmentOuterStyle(appts: Appointment[]): SafeStyle {

		const ret: string[] = [];

		let filter: FilterDialogOptions,
			num = appts.length;
		
		// we need to determine if any of the things match the 'filters', as they will in turn need to be reflected here
		// or shit will get sideways
		if (num > 1) {
			filter = this.filterOptions;
			if (!filter.showAllAppointments) {
				num = 0;
				if (filter.showCancelled) {
					num += appts.filter(a => a.cancelled).length;
				}
				if (filter.showIncomplete) {
					num += appts.filter(a => a.incomplete).length;
				}
				if (filter.showInvoiced) {
					num += appts.filter(a => a.invoiced).length;
				}
			}
			ret.push(`grid-template-columns: repeat(${num}, 1fr)`);
		}
		return this._dom.bypassSecurityTrustStyle(ret.join(';'));
	}

	getAppointmentStyle(appt: Appointment): SafeStyle {
		// we need to determine the top from the nearest block, as well as the duration
		const ret: string[] = [],
			time = appt.date.getMinutes(),
			duration = appt.duration,
			inc = this.minuteIncrement,
			incHeight = this.rowHeight,
			topPercent = (time / inc) - Math.floor(time / inc),
			height = (duration / inc) * incHeight;

		if (topPercent) {
			ret.push(`margin-top: ${incHeight * topPercent}px`);
		}
		ret.push(`height: ${height}px`);

		return this._dom.bypassSecurityTrustStyle(ret.join(';'));
	}

	updateClock() {

		const dif = Math.abs((this.maxDate.getTime() - this.minDate.getTime()) / 1000 / 60) + this.minuteIncrement, // 675 minutes from 930am to 845 + the additional 15
			now = new Date(),
			min = this.minDate.getTime(),
			max = this.maxDate.getTime(),
			nowTime = now.getTime(),
			node = this.mainElement.nativeElement,
			slug = this.headerSlug.nativeElement.offsetHeight,
			height = node.scrollHeight - slug,
			minDif = Math.abs((now.getTime() - min) / 1000 / 60),
			percent = (minDif / dif),
			val = Math.abs(height * percent) + slug - (this.timeBarThickness / 2);

		if (val < slug || nowTime < min) {
			this.currentTimeTop = slug;
		} else if (val > node.scrollHeight || nowTime > max) {
			this.currentTimeTop = node.scrollHeight - this.timeBarThickness;
		} else {
			this.currentTimeTop = val;
		}

		this._cd.detectChanges();
	}

	get isToday() {
		return this.app.isToday;
	}
	
	ngOnInit() {
		const app = this.app;

		this.dateControl
			.valueChanges
			.pipe(
				startWith(app.date.getValue()),
				debounceTime(250),
			)
			.subscribe(date => app.setDate(date));
		
		app.date
			.subscribe(date => {
				const isToday = app.isToday;

				this._load(date);

				if (isToday) {
					this._todayTimer = timer((60 - new Date().getSeconds()) * 1000, 1000 * 60).subscribe(() => this.updateClock());
				} else if (this._todayTimer && !this._todayTimer.closed) {
					this._todayTimer.unsubscribe();
				}
			});

		this.settings = this._settings.active;

		document.addEventListener('dragover', (evt: Event) => evt.preventDefault());

		fromEvent(window, 'resize')
			.pipe(
				debounceTime(33)
			)
			.subscribe(() => this._onResize());
	}

	private _onResize() {

		const max = window.innerHeight,
			cur = this.rowHeight,
			min = this.rowMinHeight,
			tit = this.titleBar, // 32
			slug = this.headerSlug,
			avail = (tit && slug) ? (max - (tit.nativeElement.offsetHeight + slug.nativeElement.offsetHeight)) : 0,
			blocks = document.querySelectorAll('.times .minute-block').length,
			val = avail && blocks ? Math.floor(avail / blocks) : 0;

		if (!val || val < min) {
			if (cur !== min) {
				this.rowHeight = min;
				this._cd.detectChanges();
				setTimeout(() => this.updateClock(), 300);
			}
		} else if (val !== cur) {
			this.rowHeight = val;
			this._cd.detectChanges();
			this.updateClock();
		}
	}

}
